import type IPressContact from '../../../../models/press/press-contact.model';
import PressHelper from '../../helpers/press-helper';
import './style.scss';

function PressContact({ pressContact }: { pressContact: IPressContact }) {
  const imageSize = '-w_200';

  function hasImage() {
    return !!pressContact.image?.path;
  }

  function getImageUrl(imagePath: string) {
    return `url("${PressHelper.addSizePropertiesToImageUrl(imagePath, imageSize)}")`;
  }

  return (
    <div className="text-center press-contact">
      {hasImage() && pressContact.image && (
        <div className="image-container d-flex align-items-center justify-content-center mb-2">
          <div className="press-contact__contact-image border-blue" style={{ backgroundPosition: pressContact.image?.focus, backgroundImage: getImageUrl(pressContact.image?.path) }}></div>
        </div>
      )}
      <strong className="mb-2 d-block">{pressContact.name}</strong>
      {pressContact.description && pressContact.description.sv && <div className="mb-2">{pressContact.description.sv}</div>}
      {pressContact.title && pressContact.title.sv && <div className="mb-2">{pressContact.title.sv}</div>}
      {pressContact.phoneNumber && (
        <a href={`tel:${pressContact.phoneNumber}`} className="d-block mb-2">
          {pressContact.phoneNumber}
        </a>
      )}
      {pressContact.mobile && (
        <a href={`tel:${pressContact.mobile}`} className="d-block mb-2">
          {pressContact.mobile}
        </a>
      )}
      {pressContact.email && (
        <a href={`mailto:${pressContact.email}`} className="d-block mb-2">
          {pressContact.email}
        </a>
      )}
    </div>
  );
}

export default PressContact;
